export * from './scopeOfWorkRevisionInternal';